import { IPoint } from "utils/types";

export enum MessageRole{
  Client="Client",
  Driver="Driver",
  Dispatcher="Dispatcher"
}

export interface IMessageStatus{
  delivered_at?: number;
  read_at?: number;
  role: MessageRole;
}

export interface IMessage{
  id?: number;
  order?: number;
  role: MessageRole;
  message: string;
  point?: IPoint|null;
  created_at: Date;
  statuses: IMessageStatus[];
  local_id?: string;
}

export const messageSerializer = (data:any):IMessage => {
  let message:IMessage = JSON.parse(JSON.stringify(data));
  
  if(data.created_at) message.created_at = new Date(data.created_at * 1000);
  return message
}